import { SVGProps } from 'react';
const SvgIconPinterestCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 41.2 41.2"
    {...props}
  >
    <g transform="translate(-171.2 -3587.2)">
      <g transform="translate(171.8 3587.8)">
        <path
          d="M51.878,63.844c.268-3.43,1.391-6.376,2-9.454-1.412-2.438.17-7.343,3.147-6.134,3.663,1.486-3.173,9.061,1.416,10.007,4.791.988,6.747-8.527,3.777-11.621-4.293-4.467-12.5-.1-11.487,6.295a9.639,9.639,0,0,0,.947,2.1,1.972,1.972,0,0,1,.029,1.289,3.947,3.947,0,0,1-.347.809c-2.748-.624-3.568-2.847-3.462-5.81a9.369,9.369,0,0,1,8.339-8.716c5.173-.594,10.029,1.948,10.7,6.94.755,5.635-2.335,11.737-7.867,11.3-1.5-.12-2.129-.881-3.3-1.614-.646,3.479-1.436,6.813-3.777,8.554"
          transform="translate(-37.026 -33.602)"
          fill="none"
          stroke="#0084f5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.2}
        />
        <path
          d="M35.66,56.377a19.977,19.977,0,1,1,5.358-.726"
          transform="translate(-15.66 -16.377)"
          fill="none"
          stroke="#231f20"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.2}
        />
      </g>
    </g>
  </svg>
);
export default SvgIconPinterestCircle;
